<template>
    <v-row>
        <v-col cols="12">
            <v-text-field 
                outlined
                v-model="localEmail"
                hide-details
                label="Email destinatario"
                @input="emitter('email_to', localEmail)"
                required>
                <template v-slot:append>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                color="primary_blue"
                                v-bind="attrs"
                                v-on="on"
                            >
                                mdi-information
                            </v-icon>
                        </template>
                        <span>Para múltiples destinatarios, sepárelos con punto y coma (;)</span>
                    </v-tooltip>
                </template>
            </v-text-field>
        </v-col>
        <v-col cols="12">
            <v-text-field 
                outlined
                v-model="localSubject"
                hide-details
                label="Asunto"
                @input="emitter('subject', localSubject)">
            </v-text-field>
        </v-col>
        <v-col cols="12">
            <v-textarea
                outlined
                v-model="localBody"
                hide-details
                label="Mensaje"
                rows="5"
                @input="emitter('body', localBody)">
            </v-textarea>
        </v-col>
    </v-row>
</template>

<script>
import { query_dispatcher } from '@/api/client';

export default {
    name: 'SendByEmailForm',
    props: {
        email_to: String,
        subject: String,
        body: String,
    },
    data() {
        return {
            localEmail: this.email_to,
            localSubject: this.subject,
            localBody: this.body
        }
    },
    methods: {
        emitter(field, value) {
            this.$emit('update:'+field, value);
        },
        async getEmail(){
            try {
                const result = await query_dispatcher.dispatch(
                    "supplier.get", 
                    { document_id: this.$store.state.documents.document.id.toString() }
                )
                this.localEmail = result.email
                this.emitter('email_to', this.localEmail)
            } catch (error) {
                console.error(error)
            }
        }
    },
    mounted() {
        this.getEmail()
    }
}
</script>